import Layout from "../../layouts/layout";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { DatePicker } from "react-advance-jalaali-datepicker";
import { useEffect, useState } from "react";
import { createSingleUser, storeSingleUsers, } from "../../api/users";
import MainPageLayout from "../../components/main-page-layout/mainPageLayout";
import { useRequestProcessor } from "../../api/requestProcessor";
import { useNavigate } from "react-router-dom";

const AddUsers = () => {

    const { Query, Mutate } = useRequestProcessor();
    const navigate = useNavigate()

    const [role, setRole] = useState([
        {
            name: "admin",
            label: "ادمین"
        },
        {
            name: "user",
            label: "کاربر عادی"
        },
    ])
    const [gender, setGender] = useState([
        {
            name: "male",
            label: "آقا"
        },
        {
            name: "female",
            label: "خانم"
        },
    ])

    const { mutate } = Mutate(
        "storeSingleUser",
        storeSingleUsers,
        {
            onSuccess: (data) => {
                toast.success(data.message)
                toast.info("تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید", {
                    autoClose: 2500,
                    pauseOnHover: false
                })
                setTimeout(() => { navigate("/admin/users") }, 3000)
            },
            onError:(data) => {
                toast.error(data.messgae)
            }
        }

    )

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();




    async function onHookFormhandler(data) {
        mutate(data)
    }



    return (
        <Layout title="ایجاد کاربر">
            <MainPageLayout title={"ایجاد کاربر جدید"} >
                <form onSubmit={handleSubmit((data) => onHookFormhandler(data))} className='flex flex-col'>
                    {/* <h1 className="text-[1.5rem]">ایجاد کاربر جدید</h1> */}
                    <div className="flex wsm:flex-col">
                        <div className='flex-col my-4 !w-full'>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.name && "text-red-500"}`}>نام :</p>
                                <input type="text" {...register("name", { required: true })} className='form-input !w-full' placeholder='نام' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.lastname && "text-red-500"}`}>نام خانوادگی:</p>
                                <input type="text" {...register("lastname", { required: true })} className='form-input !w-full' placeholder='نام خانوادگی ' />
                            </div>


                        </div>
                        <div className="flex-col my-4 !w-full mr-2">
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.level && "text-red-500"}`}>نقش :</p>
                                <select {...register("level", { required: true })} className="!w-full  border border-gray-500 py-2 px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    {
                                        role?.map(el => (
                                            <option key={el.id} className="py-3" value={el.name} >{el.label}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.phone && "text-red-500"}`}>شماره تلفن:</p>
                                <input type="number" autoComplete="new-phone" {...register("phone", { required: true, minLength: 11, maxLength: 11 })} className={`form-input !w-full`} placeholder='شماره تلفن' />
                            </div>
                            {/* <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.gender && "text-red-500"}`}>جنسیت :</p>
                                <select {...register("gender", { required: true })} className="!w-full  border border-gray-500 py-2 px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    {
                                        gender?.map(el => (
                                            <option key={el.id} className="py-3" value={el.name} >{el.label}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.phone && "text-red-500"}`}>استان و شهر :</p>
                                <div className="flex">

                                    <select {...register("role", { required: true })} className="!w-full  border border-gray-500 py-2 px-[20px] rounded-[10px] ml-4 focus:border-[#1976d2bf]" >
                                        {
                                            role?.map(el => (
                                                <option key={el.id} className="py-3" value={el.name} >{el.label}</option>
                                            ))
                                        }
                                    </select>
                                    <select {...register("role", { required: true })} className="!w-full  border border-gray-500 py-2 px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                        {
                                            role?.map(el => (
                                                <option key={el.id} className="py-3" value={el.name} >{el.label}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default AddUsers